import * as React from 'react';

import BaseIndex from '../../../shared/generics/actor_search_form/Index';

import NavigationProp from '../../../../navigators/NavigationProp';
import {CharacterFormNewActorSearchFormRouteProp} from '../../../../navigators/RouteProps';

import * as routers from '../../../../routers';

import {Params as ActorCategoryIndexParams} from '../../../../actions/actor_categories/index';
import {Params as ActorIndexParams} from '../../../../actions/actors/index';

import Actor from '../../../../../domain/entities/Actor';
import ActorCategory from '../../../../../domain/entities/ActorCategory';
import PaginatedResult from '../../../../../domain/results/PaginatedResult';

export interface Params {
  storyId: number;
  formValues?: {
    query: string;
    ageMin: number;
    ageMax: number;
    rootCategoryIdToActorCategoryIds: {[key: string]: Array<number>};
  };
  withPaid?: boolean;
  hideBack?: boolean;
}

export interface StateProps {
  navigation: NavigationProp;
  route: CharacterFormNewActorSearchFormRouteProp;
  actorCategoriesParams: ActorCategoryIndexParams;
  actorCategories: ActorCategory[] | null;
}

export interface DispatchProps {
  indexActorCategories: (
    params: ActorCategoryIndexParams,
  ) => Promise<PaginatedResult<ActorCategory>>;
  indexActors: (params: ActorIndexParams) => Promise<PaginatedResult<Actor>>;
}

interface Props extends StateProps, DispatchProps {}

export default class Index extends React.Component<Props> {
  public render(): React.ReactNode {
    const {route} = this.props;
    const {formValues, withPaid, hideBack} = route.params || {};
    return (
      <BaseIndex
        {...this.props}
        formValues={formValues}
        withPaid={withPaid}
        hideBack={hideBack}
        onPress={this.handlePress}
      />
    );
  }

  private handlePress = (params: {
    query: string;
    ageMin: number;
    ageMax: number;
    rootCategoryIdToActorCategoryIds: {[key: string]: Array<number>};
  }) => {
    const {navigation, route} = this.props;
    const {storyId, withPaid} = route.params;
    const {query, ageMin, ageMax, rootCategoryIdToActorCategoryIds} = params;
    routers.linkToCharacterFormNewActors(navigation, {
      storyId,
      formValues: {query, ageMin, ageMax, rootCategoryIdToActorCategoryIds},
      withPaid,
    });
  };
}
